// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"856":"14531f67","4110":"14531f67","6026":"14531f67","7949":"14531f67"}[chunkId] + ".chunk.css";
};